<template>
  <transition :name="profileType">
    <div
      v-show="menuActive"
      v-click-outside="handleOutside"
      :class="['h-full z-10 wrapper', profileType]"
    >
      <div
        ref="content"
        class="content"
        :style="{
          'padding-top': `${clewordNavVisible ? setyleNavHeight : 0}px`
        }"
      >
        <div class="headling-title-warpper">
          <div class="headling-title">课程大纲</div>
          <div class="cursor-pointer mr-4 w-4 hover:opacity-70" @click="handleHide(false)">
            <img src="../../assets/close.svg" alt="关闭" />
          </div>
        </div>
        <div
          v-if="sequence.headlines"
          :class="['menu-list', menuActive ? '' : 'menu-list--collapse']"
        >
          <div v-for="(headline, index) in sequence.headlines" :key="index" class="mx-2">
            <a
              href="javascript:;"
              :class="menuItemClasses(headline)"
              @click="$emit('jump', headline)"
            >
              <Headling class="p-2 text-xl" :level="headline.level">
                {{ headline.title }}
              </Headling>
            </a>
          </div>
        </div>
        <div v-else class="empty">
          <img class="w-1/2" src="../../assets/empty.svg" />
          <span class="text-gray-400 text-sm mt-4">当前还没有课程大纲</span>
        </div>
      </div>
    </div>
  </transition>
</template>
<script lang="ts">
import { Content, Sequence } from '@forchange/storytime';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import Headling from '@/components/headling';
import TipIcon from '../../assets/TipIcon.vue';

import clickOutside from 'vue-click-outside';

const commonModal = namespace('common');

const LOCALSTORAGE_KEY = 'surfer-initiative-close';

@Component({
  components: {
    Headling,
    TipIcon
  },
  directives: {
    clickOutside
  }
})
export default class MenuList extends Vue {
  @Prop({ type: Object }) sequence!: Sequence & {
    headlines: Array<{ title: string; level: number }>;
    progressShow?: '隐藏' | 'hidden';
  };
  @Prop({ type: Boolean }) scroling: boolean;
  @Prop({ type: Array }) targetDataId: Array<string>;
  @commonModal.State('menuActive') menuActive: boolean;
  @commonModal.State('setyleNavHeight') setyleNavHeight: number;
  @commonModal.State('clewordNavVisible') clewordNavVisible: boolean;

  // 侧面宽度展示状态
  profileType: 'menu-absolute' | 'menu-fixed' = 'menu-fixed';
  // 是否主动关闭
  initiativeClose = false;

  mounted() {
    this.initInitiativeClose();
    this.initPosition();
  }

  @Watch('menuActive')
  menuActiveChange() {
    this.$nextTick(() => {
      this.resizeCallback();
    });
  }

  initPosition() {
    this.$nextTick(() => {
      this.resizeCallback();
      window.addEventListener('resize', this.resizeCallback);

      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('resize', this.resizeCallback);
      });
    });
  }
  resizeCallback() {
    const contentEl = this.$refs.content as HTMLDivElement;
    if (!contentEl) return;
    const profileWidth = (window.innerWidth - 1200) / 2;
    const isExceedWidth = contentEl.offsetWidth > profileWidth;
    this.profileType = isExceedWidth ? 'menu-fixed' : 'menu-absolute';
    if (!this.sequence.headlines) return;
    if (this.initiativeClose || isExceedWidth) return;
    this.$store.commit('common/setMenuActive', { menuActive: true });
  }

  handleOutside() {
    if (this.profileType === 'menu-absolute') return;
    this.handleHide(true);
  }

  handleHide(isOutside: undefined | Boolean) {
    if (!isOutside) {
      this.initiativeClose = true;
      // 以免重复弹出
      window.localStorage.setItem(LOCALSTORAGE_KEY, 'true');
    }
    this.$store.commit('common/setMenuActive', { menuActive: false });
  }

  clickabled(title: string) {
    const headlines = this.sequence.contents.filter((item) => item.$kind === 'Headline') as Array<
      Content & { title: string; level: number }
    >;
    return headlines.some((headline: { title: string; level: number }) => headline.title === title);
  }

  menuItemClasses(headline: { title: string; level: number }) {
    const classes = {
      'menu-list_item': true,
      clickabled: false,
      active: false
    };

    if (this.clickabled(headline.title)) {
      classes.clickabled = true;
    }

    if (this.scroling) return classes;

    if (this.targetDataId[this.targetDataId.length - 1] === this.transfromId(headline.title)) {
      classes.active = true;
    }

    return classes;
  }

  transfromId(title: string) {
    return `id_${title.replace(/"/g, '_DOUBLEQUOTE_')}`;
  }

  initInitiativeClose() {
    const initiativeClose = Boolean(window.localStorage.getItem(LOCALSTORAGE_KEY));
    this.initiativeClose = initiativeClose;
  }
}
</script>
<style scoped>
.menu-absolute.menu-wrapper {
  box-shadow: none !important;
  transform: translateX(-100%);
}

.menu-fixed-enter,
.menu-fixed-leave-to {
  transform: translateX(-100%);
}
.menu-fixed-enter-active,
.menu-fixed-leave-active {
  transition: 0.3s;
}

.menu-absolute-enter,
.menu-absolute-leave-to {
  opacity: 0;
}
.menu-absolute-enter-active,
.menu-absolute-leave-active {
  transition: 0.3s;
}

.menu-absolute {
  @apply absolute;
  transform: translateX(-100%);
}
.menu-fixed {
  @apply fixed left-0 shadow-right;
}

.content {
  @apply h-full overflow-y-scroll bg-white;
  transition: 0.5s all;
}
.menu-absolute .content {
  background-color: transparent;
}

.headling-title-warpper {
  @apply h-12 flex items-center justify-between mx-4 mt-8;
  border-bottom: 1px solid rgba(101, 110, 143, 0.2);
}

.headling-title {
  @apply font-semibold text-xl;
  color: #333333;
  font-size: 20px;
}

.menu-list {
  @apply relative flex-shrink-0 pt-4 min-w-60 max-w-sm overflow-y-auto;
}
.menu-list--collapse > .menu-list_wrapper {
  @apply hidden;
}
.menu-list_item {
  @apply block relative box-border py-2;
  color: rgba(194, 193, 198, 0.6);
  cursor: not-allowed;
}
.menu-list_item.clickabled {
  @apply text-gray-700 cursor-pointer pointer-events-auto hover:text-motif-500;
}
.menu-list_item.active {
  @apply text-motif-500 rounded-md;
}
.menu-closer {
  @apply absolute z-10 -right-5 top-5 w-10 h-10;
}
.menu-closer--collapse {
  left: 100%;
}
.empty {
  @apply relative top-1/2 flex flex-col items-center justify-center w-60;
  transform: translateY(-90%);
}
</style>
